import React,{useState} from 'react'
import './SearchBar.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faSearch} from '@fortawesome/free-solid-svg-icons'

const SearchBar = () => {
    const [search,setSearch] = useState({searchbar:''})

    return (
        <>
            <div className="searchbar__container">
                <div className="searchbar__search">
                    <input 
                        type="text"
                        name="search"
                        className="search"
                        placeholder="Search Games ..."
                        value={search.searchbar}
                        onChange = {(e) => setSearch({...search,searchbar:e.target.value})}    
                    />
                    <div className="icon-search">
                        <FontAwesomeIcon icon={faSearch} size='lg'/>
                    </div> 
                </div>
            </div>
        </>
    )
}

export default SearchBar
